// Production
export const backendUrl = 'https://check2check-backend.herokuapp.com/'

// Development
// export const backendUrl = 'http://localhost:3001/'
